module.exports = __webpack_public_path__ + "static/6-6e481553061d0d896950c81537c25e9f.jpeg";